import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import styles from './CartSidebar.module.css';

function CartSidebar() {
    const navigate = useNavigate();
    const { sidebarOpen, sidebarItems, closeCartSidebar, cartCount } = useCart();

    const total = sidebarItems.reduce((sum, item) => sum + item.totalPrice, 0);

    return (
        <>
            {sidebarOpen && (
                <div className={styles.overlay} onClick={closeCartSidebar} />
            )}
            <div className={`${styles.sidebar} ${sidebarOpen ? styles.open : ''}`}>
                <div className={styles.header}>
                    <h3 className={styles.title}>장바구니 ({cartCount})</h3>
                    <button className={styles.closeBtn} onClick={closeCartSidebar}>✕</button>
                </div>

                <div className={styles.items}>
                    {sidebarItems.length === 0 ? (
                        <p className={styles.empty}>장바구니가 비어있습니다.</p>
                    ) : (
                        sidebarItems.map(item => (
                            <div key={item.cartId} className={styles.item}>
                                <img
                                    src={`http://localhost:8080${item.imageUrl}`}
                                    alt={item.productName}
                                    className={styles.itemImage}
                                    onClick={() => { navigate(`/products/${item.productId}`); closeCartSidebar(); }}
                                />
                                <div className={styles.itemInfo}>
                                    <p className={styles.itemName}
                                        onClick={() => { navigate(`/products/${item.productId}`); closeCartSidebar(); }}>
                                        {item.productName}
                                    </p>
                                    {item.optionName && (
                                        <p className={styles.itemOption}>
                                            {item.optionName}: {item.optionValue}
                                        </p>
                                    )}
                                    <p className={styles.itemPrice}>
                                        {item.quantity}개 · {item.totalPrice.toLocaleString()}원
                                    </p>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                <div className={styles.footer}>
                    <div className={styles.totalRow}>
                        <span>총 금액</span>
                        <span className={styles.totalPrice}>{total.toLocaleString()}원</span>
                    </div>
                    <button className={styles.orderBtn} onClick={() => { navigate('/order'); closeCartSidebar(); }}>
                        주문하기
                    </button>
                    <button className={styles.cartBtn} onClick={() => { navigate('/cart'); closeCartSidebar(); }}>
                        장바구니 보기
                    </button>
                    <button className={styles.continueBtn} onClick={closeCartSidebar}>
                        쇼핑 계속하기
                    </button>
                </div>
            </div>
        </>
    );
}

export default CartSidebar;